import { timestampOptimizer } from '@/store/recap';
export class Video {
    #video;
    #timeStamps = [];
    #duration = 0;
    #currentTimeStamp = 0;
    #isDetatched = false;
    currentTime = 0;
    #onTimeupdateCallback = (event) => { };
    #onFrameupdateCallback = (currentTime, frame) => { };
    #onBufferingCallback = () => { };
    #fps;
    constructor(videoElement, timeStamps, fps) {
        this.#video = videoElement;
        this.setNewTimestamps(timeStamps);
        this.#fps = fps || 30;
        let currentTime = 0;
        const timeupdate = () => {
            if (this.#isDetatched)
                return;
            const videoCurrentTime = this.#video.currentTime;
            const currentTimeStamp = this.#timeStamps[this.#currentTimeStamp];
            const nextTimeStamp = this.#timeStamps[this.#currentTimeStamp + 1];
            if (this.#previousTime === videoCurrentTime) {
                this.#previousRepeatCount += 1;
            }
            if (this.#previousRepeatCount >= this.#maxPreviousRepeat) {
                this.#previousTime = videoCurrentTime;
                this.#previousRepeatCount = 0;
                this.#onBufferingCallback();
                return;
            }
            currentTime = videoCurrentTime - currentTimeStamp.startDuration + currentTimeStamp.currentLength;
            if (videoCurrentTime < currentTimeStamp.startDuration) {
                this.#video.currentTime = currentTimeStamp.startDuration;
                this.currentTime = currentTime;
                console.log('NEXT TIMESTAMP', currentTime);
                this.#onTimeupdateCallback({ currentTime, videoTime: this.#video.currentTime });
                return;
            }
            if (videoCurrentTime < currentTimeStamp.endDuration) {
                this.#onTimeupdateCallback({ currentTime, videoTime: this.#video.currentTime });
                return;
            }
            if (!nextTimeStamp) {
                console.log('RESET', { nextTimeStamp, timeStamps, currentTimeStamp });
                this.#video.pause();
                this.#currentTimeStamp = 0;
                this.#video.currentTime = this.#timeStamps[0].startDuration;
                this.#onTimeupdateCallback({ currentTime: 0, videoTime: this.#video.currentTime });
                console.log('RESET TIMESTAMP');
                return;
            }
            this.#video.currentTime = nextTimeStamp.startDuration;
            this.#currentTimeStamp += 1;
        };
        this.#video.addEventListener('timeupdate', timeupdate);
        this.destroy = () => this.#video.removeEventListener('timeupdate', timeupdate);
        const frameCounter = () => {
            const videoCurrentTime = this.#video.currentTime;
            let currentTimeStamp = null;
            for (let i = 0; i < this.#timeStamps.length; i++) {
                const value = this.#timeStamps[i];
                if (videoCurrentTime >= value.startDuration && videoCurrentTime <= value.endDuration) {
                    currentTimeStamp = value;
                    break;
                }
            }
            if (!currentTimeStamp) {
                this.#video.requestVideoFrameCallback(frameCounter);
                return;
            }
            const currentTime = parseFloat((videoCurrentTime - currentTimeStamp.startDuration + currentTimeStamp.currentLength).toFixed(3));
            const frame = parseInt((currentTime * this.#fps).toFixed(0));
            this.#onFrameupdateCallback(currentTime, frame);
            this.#video.requestVideoFrameCallback(frameCounter);
        };
        this.#video.requestVideoFrameCallback(frameCounter);
    }
    detatchVideo = () => {
        this.#isDetatched = true;
    };
    attachVideo = () => {
        this.#isDetatched = false;
    };
    onFrameupdate = (callback) => {
        this.#onFrameupdateCallback = callback;
    };
    onTimeupdate = (callback) => {
        this.#onTimeupdateCallback = callback;
    };
    onBuffering = (callback) => {
        this.#onBufferingCallback = callback;
    };
    #previousTime = -1;
    #previousRepeatCount = 0;
    #maxPreviousRepeat = 10;
    play = async () => {
        if (!this.#video.paused) {
            this.#video.pause();
            return;
        }
        await this.#video.play();
    };
    pause = () => {
        if (!this.#video.paused)
            this.#video.pause();
    };
    stop = () => {
        this.pause();
        this.seek(0);
    };
    seek = (time) => {
        for (let i = 0; i < this.#timeStamps.length; i++) {
            const timeStamp = this.#timeStamps[i];
            if (time <= timeStamp.totalLength) {
                const timestampLength = timeStamp.endDuration - timeStamp.startDuration;
                const progressDifference = time / timeStamp.totalLength;
                const calculatedDuration = timeStamp.startDuration + timestampLength * progressDifference;
                this.#currentTimeStamp = i;
                this.#video.currentTime = calculatedDuration;
                return;
            }
        }
        this.#video.currentTime = 0;
        this.#currentTimeStamp = 0;
    };
    duration = () => this.#duration;
    setNewTimestamps = (newTimeStamps) => {
        this.stop();
        newTimeStamps = timestampOptimizer(newTimeStamps);
        this.#video.currentTime = this.#timeStamps[0]?.startDuration || 0;
        this.#timeStamps = [];
        this.#currentTimeStamp = 0;
        this.#duration = 0;
        for (let i = 0; i < newTimeStamps.length; i++) {
            const timeStamp = newTimeStamps[i];
            const length = Math.abs(timeStamp.startDuration - timeStamp.endDuration);
            const currentLength = this.#duration;
            const totalLength = this.#duration + length;
            this.#duration = totalLength;
            this.#timeStamps.push({ ...timeStamp, length, totalLength, currentLength });
        }
        // console.log("NEW TIMESTAMP", newTimeStamps, this.#duration, this.#timeStamps);
    };
    destroy = () => { };
}
